module.exports = __webpack_public_path__ + "static/media/info_drone_support_icon.4d63b90a.svg";